import React, { FC } from 'react';
import styles from './textbook-header.module.scss';
import { Navigate } from '../../constants';
import { SelectCategory } from '../select-category/SelectCategory';

interface BookHeaderProps {
  page: number;
  onPageNavigate: (navigation: Navigate) => void;
  onGroupClick: (group: number) => void;
  group: number;
  onPaginationClick: (page: number) => void;
}

export const HeaderTextBook: FC<BookHeaderProps> = ({
  onPageNavigate,
  page,
  onGroupClick,
  group,
  onPaginationClick,
}) => {
  return (
    <div className={styles.wrapper}>
      <SelectCategory onGroupClick={onGroupClick} group={group} />
    </div>
  );
};
